<template>
    <layout-basic>
        <section class="banner-text padding-bottom feature">
            <v-row no-gutters>
                <v-col class="banner-wrapper">
                    <!-- Shape Background -->
                    <div class="why-improve-shape-background">
                        <img class="why-improve-background-image border-bottom" :src="getImageSource(
                            'improve-features-page-main-header-background.png',
                            'features/banner'
                        )
                            " />

                        
                    </div>
                    <v-container class="banner-img-text-wrapper pb-0">
                        <!-- Banner Left Wrapper -->
                        <div class="banner-left-wrapper">
                            <div id="main-banner-wrapper">
                                <img class="feature-rounded-rectangle-image" :src="getImageSource(
                                    'rounded-rectangle-green.png',
                                    'features/banner'
                                )
                                    " />
                                <div class="banner-text-overlay">
                                    TAILORED TRAINING FOR BUSINESSES
                                </div>
                            </div>
                            <div class="banner-main-title">
                                Your Intuitive Microlearning Solution
                            </div>
                            <div class="banner-sub-text feature-banner-sub-text">
                                IMPROVE's affordable microlearning solution streamlines staff training.
                                Upload your own resources to keep the training relevant to your business.
                            </div>
                        </div>
                        
                        <img class="features-training-progress-image" :src="getImageSource(
                            'improve-online-training-progress.png',
                            'features/banner'
                        )"/>
                        <img class="features-dashboard-progress-image" :src="getImageSource(
                            'improve-dashboard-progress.png',
                            'features/banner'
                        )
                            " />
                            <img class="features-courses-image" :src="getImageSource(
                            'improve-online-training-courses.png',
                            'features/banner'
                        )
                            " />
                        <img class="features-resources-image" :src="getImageSource(
                            'improve-resources.png',
                            'features/banner'
                        )
                            " />
                            
                    </v-container>
                </v-col>
            </v-row>
        </section>
        <section class="improve-customers">
            <v-row class="text-center mt-10">
                <v-container style="padding: 0 25px">
                    <div class="carousel-title">
                        Organisations across multiple sectors using IMPROVE
                    </div>
                    <v-col class="pa-0" cols="12" md="12" p>
                        <VueSlickCarousel v-bind="imageCarousel">
                            <template #prevArrow="arrowOption">
                                <div class="custom-carousel-button">
                                    <span><i class="fa fa-chevron-left"></i></span>
                                </div>
                            </template>
                            <template #nextArrow="arrowOption">
                                <div class="custom-carousel-button">
                                    <span><i class="fa fa-chevron-right"></i></span>
                                </div>
                            </template>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/advoacy-focus.png" class="img-fluid"
                                    alt="Advocacy Focus Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/east-midlands-chamber.png" class="img-fluid"
                                    alt="East Midlands Chamber Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/eden-holistic-pet-foods.png" class="img-fluid"
                                    alt="Eden Holistic Pet Foods Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/effectech.png" class="img-fluid"
                                    alt="Effectech Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/hr-central-human-resources-consultancy.jpg" class="img-fluid"
                                    alt="HR Central Human Resources Consultancy Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/hope-nottingham.png" class="img-fluid"
                                    alt="Hope Nottingham Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/la-micro.png" class="img-fluid"
                                    alt="La Micro Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/laceys-solicitors.png" class="img-fluid"
                                    alt="Laceys Solicitors Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/m-j-r.png" class="img-fluid"
                                    alt="M J R Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/people-value.png" class="img-fluid"
                                    alt="People Value Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/pilkington.png" class="img-fluid"
                                    alt="Pilkington Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/tevva.png" class="img-fluid"
                                    alt="Tevva Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/APK_Group_IMPROVE_Customer.png" class="img-fluid"
                                    alt="APK Group Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/3SC_IMPROVE_Customer.png" class="img-fluid"
                                    alt="3SC Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/Advonet_Group_IMPROVE_Customer.png"
                                    class="img-fluid" alt="Advonet Group Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/Boostwork_IMPROVE_Customer.png" class="img-fluid"
                                    alt="Boostwork Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/BPX_IMPROVE_Customer.png" class="img-fluid"
                                    alt="BPX Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/Carter_IMPROVE_Customer.png" class="img-fluid"
                                    alt="Carter Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/China-Britain-Business-Council-IMPROVE-Customer.png"
                                    class="img-fluid" alt="China Britain Business Council Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/Council-of-Deans-of-Heath-IMPROVE-Customer.png"
                                    class="img-fluid" alt="Council of Deans of Health Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/Devon-Community-Foundation-IMPROVE-Customer.jpg"
                                    class="img-fluid" alt="Devon Community Foundation Approved IMPROVE partner" />
                            </div>
                            <div class="customers-item">
                                <img src="/static/homepage/carousel/IP-Group-IMPROVE-Customer.png" class="img-fluid"
                                    alt="IP Group Approved IMPROVE partner" />
                            </div>
                        </VueSlickCarousel>
                    </v-col>
                </v-container>
            </v-row>
        </section>
        <hr />
        <section style="margin-top: 80px;margin-bottom: 50px;">
            <v-row no-gutters>
                <v-col cols="12" align-self="center">
                    <v-container>
                        <div class="why-improve-title text-center">
                            <h2>Effortlessly Upskill and Train Staff</h2>

                            <span>Experience a user-friendly online training platform designed for businesses.</span>

                            <p>
                                IMPROVE is designed to provide tailored training to help upskill, train, and enrol your
                                staff.
                                You can upload your own documents to ensure the training is relevant to your business's
                                needs.
                            </p>
                        </div>
                    </v-container>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" align-self="center" no-gutters>
                    <v-container style="padding: 0 15px;">
                        <div class="compliance-training-wrapper">
                            <div class="compliance-training-content">
                                <h1>Cost Effective</h1>

                                <span>Affordable training for your business. </span>

                                <p>
                                    We believe that <b>online training</b> should be <b>easily accessible</b>. With
                                    IMPROVE, you can access our <b>intuitive platform</b> and <b>off-the-shelf
                                        courses</b>
                                    from just <b>£495 per year</b>.
                                </p>

                                <h1>Add Documents</h1>

                                <span>Courses that align with your business. </span>

                                <p>
                                    <b>IMPROVE</b> enables you to <b>upload your own documents</b> to courses,
                                    ensuring your <b>staff's training materials</b> are <b>aligned with your
                                        business</b>.
                                </p>
                            </div>
                            <img class="compliance-training-image" :src="getImageSource(
                                'cost-effective-online-training-platform.png',
                                'features/staff-dev'
                            )
                                " />
                        </div>
                    </v-container>
                </v-col>
            </v-row>
        </section>
        <section style="margin-bottom: 50px;">
            <v-container class="training-container">
                <VueSlickCarousel v-bind="trainingCarousel" style="padding: 0;">
                    <div class="training-item">
                        <div class="training-info-card">
                            <img src="/static/features/track-progress-icon.png" alt="Track Progress Icon">
                            <h2>Track Progress</h2>
                            <span>Insights into staff training.</span>
                            <p>IMPROVE gives you an overview of training courses completed by your staff and the overall
                                course completion rates, allowing you to track their progress.</p>
                        </div>
                    </div>
                    <div class="training-item">
                        <div class="training-info-card">
                            <img src="/static/features/user-friendly-icon.png" alt="User-friendly Icon">
                            <h2>User-friendly</h2>
                            <span>Intuitive design.</span>
                            <p>IMPROVE has an intuitive interface for both admin and staff, allowing even those with
                                little technical knowledge to easily access their courses with a single touch.</p>
                        </div>
                    </div>
                    <div class="training-item">
                        <div class="training-info-card">
                            <img src="/static/features/24-7-access-icon.png" alt="24/7 Access Icon">
                            <h2>24/7 Access</h2>
                            <span>Staff training on any device.</span>
                            <p>Staff can access their training courses any time, on any device, providing a flexible
                                solution for upskilling and onboarding your staff.</p>
                            <br>    
                        </div>
                    </div>
                    <div class="training-item">
                        <div class="training-info-card">
                            <img src="/static/features/external-training-icon.png" alt="External Training Icon">
                            <h2>External Training</h2>
                            <span>Import past training data.</span>
                            <p>Centralise all of your business’s training data and keep organised by uploading external
                                training information for your staff directly to our platform.</p>
                        </div>
                    </div>
                </VueSlickCarousel>
            </v-container>
        </section>
        <hr />
        <section style="margin: 80px 0;">
            <v-row no-gutters>
                <v-col cols="12" align-self="center">
                    <v-container>
                        <div class="hr-integration-title text-center">
                            <h2>HR Application Integration</h2>
                            <span>
                                Streamline your user management process.
                            </span>
                            <p>
                                Directly import staff data into IMPROVE from these HR applications...</p>
                        </div>
                        <v-col cols="12" md="12" p>
                            <div class="logo-grid">
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-sense-hr.png" alt="Sense HR">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-breathe-hr.png" alt="Breathe">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-sage-hr.png" alt="Sage">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-people-hr.png" alt="People">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-bamboohr-integration.png" alt="Bamboohr">
                                </div>
                                <div class="logo-item no-cursor">
                                    <img src="/static/hr-integration/improve-and-iris.png" alt="Iris">
                                </div>
                            </div>
                            <a href="/hr-integrations" class="integration-btn">
                              Learn More
                            </a>
                        </v-col>
                    </v-container>
                </v-col>
            </v-row>
        </section>
        <hr />    
        <section style="position: relative; margin-bottom: 40px;">
      <img
        v-if="screenSize === 'desktop' || screenSize === 'mobile'"
        class="scalable-img-overlay"
        :src="
          getImageSource(
            'scalable-learning-platform-shape.png',
            'features/staff-dev'
          )
        "
      />
      <v-row no-gutters>
        <v-col cols="12" align-self="center" no-gutters>
          <v-container style="padding: 0 15px;">
            <div class="staff-dev-wrapper">
              <img
                class="scalable-image pe-md-5"
                :src="
                  getImageSource(
                    'courses-to-develop-your-staff.png',
                    'features/staff-dev'
                  )
                "
              />
              <div class="staff-dev-content ps-md-5">
                <h1>Scalable Platform</h1>

                <span>Expanding your business? </span>

                <p>
                    As your company grows, <b>adding more users</b> to our 
                    platform couldn’t be easier, 
                    ensuring <b>professional development</b> across your organisation.
                </p>

                <h1>Personalised Certificates</h1>

                <span>Receive certificates upon course completion. </span>

                <p>
                    Staff can recognise their own <b>achievements</b>, 
                    encouraging them to engage in further <b>learning and development</b>
                    opportunities.
                </p>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
        </section>
        <hr />
        <section>
        <v-row>
            <v-col cols="12" align-self="center">
            <v-container>
                <div class="testimonial-title text-center">
                <img
                    src="/static/homepage/testimonial/improve-customer-testimonials.png"
                />

                <h2>Customer Testimonials</h2>

                <p>
                    What our customers say about IMPROVE
                </p>
                </div>
            </v-container>
            </v-col>
        </v-row>
        <v-container>
            <VueSlickCarousel v-bind="testimonialCarousel">
            <div class="testimonial-item">
                <div class="testimonial-card">
                <div>
                    <h2>“Flexible and Limitless”</h2>
                    <p>
                    “The system is like no other in the market. HRCentral Limited 
                    and our clients are continually impressed by the user-friendly, 
                    flexible and limitless training opportunities IMPROVE can offer.”
                    </p>
                </div>
                <img
                    src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                    alt="Smart Space Approved IMPROVE partner"
                />
                </div>
            </div>
            <div class="testimonial-item">
                <!-- <img
                src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
                class="testimonial-placeholder-circle"
                /> -->
                <div class="testimonial-card">
                <div>
                    <h2>“The Best Onboarding Process”</h2>
                    <p>
                    “New staff have been in ‘awe’ of our onboarding process which
                    is all centrally delivered via IMPROVE. We have found it to be
                    the best onboarding process we have experienced.”
                    </p>
                </div>
                <img
                    src="/static/homepage/testimonial/advocacy-focus-testimonial.png"
                    alt="Advocacy Focus Approved IMPROVE partner"
                />
                </div>
            </div>
            <div class="testimonial-item">
                <!-- <img
                src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
                class="testimonial-placeholder-circle"
                /> -->
                <div class="testimonial-card">
                <div>
                    <h2>“Comprehensive & Easy to Access”</h2>
                    <p>
                    “It’s authoritative, accurate, comprehensive, and easy to
                    access. It removes the stress of training delivery from
                    business owners, knowing that they can review what their staff
                    are learning.”
                    </p>
                </div>
                <img
                    src="/static/homepage/testimonial/smart-space-testimonial.png"
                    alt="Smart Space Approved IMPROVE partner"
                />
                </div>
            </div>
            <div class="testimonial-item">
                <div class="testimonial-card">
                <div>
                    <h2>“Consistently Impressed”</h2>
                    <p>
                    “As a proud partner of IMPROVE, we have been consistently impressed with the 
                    customer service and support we have received from the team. They are responsive, 
                    go out of their way to help, and adapt to support our needs and growth as a HR 
                    consultancy, which in turn supports our clients.”
                    </p>
                </div>
                <img
                    src="/static/homepage/testimonial/hr-central-human-resources-consultancy.jpg"
                    alt="Smart Space Approved IMPROVE partner"
                />
                </div>
            </div>
            <div class="testimonial-item">
                <!-- <img
                src="/static/homepage/testimonial/testimonial-placeholder-circle.png"
                class="testimonial-placeholder-circle"
                /> -->
                <div class="testimonial-card">
                <div>
                    <h2>“Seamless Training Process”</h2>
                    <p>
                    “The user-friendly interface has been built to ensure that
                    everyone can use it with ease, and the courses are tailored to
                    suit each team member's learning needs.”
                    </p>
                </div>
                <img
                    src="/static/homepage/testimonial/eden-holistic-pet-foods-testimonial.png"
                    alt="Eden Holistic Pet Foods Approved IMPROVE partner"
                />
                </div>
            </div>
            </VueSlickCarousel>
        </v-container>
        </section>
        <section class="animate-cat-on-scroll">
        <v-row no-gutters>
            <v-col no-gutters>
            <!-- Shape Background -->
            <div class="demo-background">
                <img
                class="demo-background-image"
                :src="
                    getImageSource(
                    'business-training-solution-free-trial.jpg',
                    'why-improve/demo'
                    )
                "
                />
                <img
                class="demo-background-cat"
                :src="
                    getImageSource(
                    'training-courses-for-smes-with-improve.png',
                    'homepage/demo'
                    )
                "
                />
                <div class="demo-content">
                <h2 style="color: #ffffff !important;">Request a Free Trial</h2>
                <p style="color: #E7F8FF !important;">
                    Learn more about IMPROVE’s features and how they can enhance staff <br/> training for your business.
                </p>
                <a
                    :href="directUrl + '/#/signup?ref=website'"
                    class="book-demo-btn"
                >
                    Get Started
                </a>
                </div>
            </div>
            </v-col>
        </v-row>
        </section>
    </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { screensize } from '../../utils/screensize';
import { IMPROVE_CONFIG } from '@/config.js';
// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
    name: "Features",
    metaInfo() {
        return {
            title: "IMPROVE Features: Intuitive, Customisable Microlearning Platform",
            meta: [
                // Meta Description
                { name: 'description', content: "Discover IMPROVE's powerful features: track progress, upload custom documents, HR integration, and affordable online training for SMEs. Upskill and train staff with ease." },
                
                // Keywords
                { name: 'keywords', content: "IMPROVE features, online training tools, microlearning platform, SME staff training, HR integration, customisable courses, track progress, affordable training solutions" },
                
                // Open Graph / Facebook Tags
                { property: 'og:title', content: "IMPROVE Features: Intuitive, Customisable Microlearning Platform" },
                { property: 'og:description', content: "Explore IMPROVE's features: track staff progress, HR integration, upload custom training documents, and offer scalable online learning for SMEs." },
                { property: 'og:image', content: "https://www.improve.online/static/seo.png" },
                { property: 'og:type', content: "website" },
                { property: 'og:url', content: "https://www.improve.online/features" },
                
                // Twitter Tags
                { name: 'twitter:card', content: "summary_large_image" },
                { name: 'twitter:title', content: "IMPROVE Features: Intuitive, Customisable Microlearning Platform" },
                { name: 'twitter:description', content: "Discover IMPROVE's features: track progress, upload custom documents, HR integration, and affordable online training designed for SMEs." },
                { name: 'twitter:image', content: "https://www.improve.online/static/seo.png" }
            ],
            link: [
                // Canonical URL
                { rel: 'canonical', href: "https://www.improve.online/features" }
            ]
        };
    },
    components: {
        LayoutBasic,
        VueSlickCarousel,
    },
    data() {
        return {
            screenSize: currentScreenSize,
            imageCarousel: {
                arrows: true,
                infinite: true,
                autoplay: true,
                speed: 300,
                slidesToShow: 7,
                slidesToScroll: 1,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 959,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 599,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 350,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },
            trainingCarousel: {
                infinite: true,
                autoplay: true,
                dots: true,
                speed: 300,
                slidesToShow: 4,
                slidesToScroll: 1,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 959,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            },
            testimonialCarousel: {
        infinite: true,
        autoplay: true,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 959,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        // Listen for scroll events
        window.addEventListener('scroll', this.handleScroll);
        // Initial check when the component mounts
        this.handleScroll();
    },
    methods: {
        // Method to handle screen size changes
        handleResize() {
            this.screenSize = getCurrentScreenSize();
        },
        // Method to dynamically generate the image source based on screen size
        getImageSource(imageName, filepath) {
            return `/static/${filepath}/${this.screenSize}/${imageName}`;
        },
        handleScroll() {
            const catElemet = this.$el.querySelector('.animate-cat-on-scroll');

      const catRect = catElemet.getBoundingClientRect();
      const catInViewport =
        catRect.top >= 0 &&
        catRect.left >= 0 &&
        catRect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        catRect.right <=
          (window.innerWidth || document.documentElement.clientWidth);

      if (catInViewport) {
        catElemet.classList.add('animate');
      }
        },
    },
    beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);

    // Remove event listener when component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
